import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2, ShieldCheck } from "lucide-react";
import api from "../../lib/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "No se pudo actualizar la contraseña.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("La nueva contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (next !== confirm) {
      toast.error("La confirmación no coincide");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/auth/change-password", { current_password: current, new_password: next });
      if (res.data?.token) localStorage.setItem("jauja_token", res.data.token);
      toast.success("Contraseña actualizada correctamente");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "mt-1.5 w-full rounded-lg border border-zinc-300 bg-white px-3 py-2.5 text-sm text-zinc-900 outline-none transition-colors focus:border-jauja-olive focus:ring-1 focus:ring-jauja-olive";

  return (
    <div className="max-w-lg">
      <div className="rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm" data-testid="change-password-card">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-jauja-olive/10 text-jauja-olive"><KeyRound size={18} /></span>
          <div>
            <h3 className="font-display text-xl text-zinc-900">Cambiar contraseña</h3>
            <p className="text-sm text-zinc-500">Actualiza la contraseña de tu cuenta de administrador.</p>
          </div>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="change-password-form">
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wide text-zinc-500">Contraseña actual</span>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" autoComplete="current-password" className={inputCls} required />
          </label>
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wide text-zinc-500">Nueva contraseña</span>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" autoComplete="new-password" className={inputCls} required />
            <span className="mt-1 block text-xs text-zinc-400">Mínimo 8 caracteres.</span>
          </label>
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wide text-zinc-500">Confirmar nueva contraseña</span>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" autoComplete="new-password" className={inputCls} required />
          </label>

          <button type="submit" disabled={loading} data-testid="cp-submit" className="inline-flex items-center gap-2 rounded-lg bg-jauja-olive px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-jauja-olive/90 disabled:opacity-50">
            {loading ? <Loader2 size={16} className="animate-spin" /> : <ShieldCheck size={16} />} Actualizar contraseña
          </button>
        </form>
      </div>
    </div>
  );
}
